module.exports = __webpack_public_path__ + "img/SWP_Shield_04 (1).9a89c73c.png";